export const install = (iframeId) => {
  const scriptId = `iframe-resizer`;

  if (document.getElementById(iframeId)) return;

  const { head } = document;
  const script = document.createElement('script');
  script.id = scriptId;
  script.type = 'text/javascript';
  script.async = true;
  script.innerText = `
    window.addEventListener('message', function(event) {
      if (event.origin === "https://competitions-monclub-staging.ffr2.nextmap.cloud" || event.origin === "https://competitions-monclub-dev.ffr2.nextmap.cloud") {
        var iframeSize = event.data;

        var iframe = document.getElementById('${iframeId}');

        if (iframe) {
          iframe.style.height = iframeSize.height + 'px';
          iframe.style.width = iframeSize.width + 'px';
        }
      }
    });
  `;
  
  head.insertBefore(script, head.firstChild);

};

export default install;
